module.exports = __webpack_public_path__ + "media/product/instagram-6-84884688.jpg";